
// // // // // Delete a story b
// // // // import React, { useState, useEffect } from "react";
// // // // import {
// // // //   TextField,
// // // //   Button,
// // // //   Box,
// // // //   Typography,
// // // //   MenuItem,
// // // //   Select,
// // // //   InputLabel,
// // // //   FormControl,
// // // //   CircularProgress,
// // // //   List,
// // // //   ListItem,
// // // //   ListItemText,
// // // //   Snackbar,
// // // //   Alert,
// // // //   Table,
// // // //   TableBody,
// // // //   TableCell,
// // // //   TableContainer,
// // // //   TableHead,
// // // //   TableRow,
// // // //   Paper,
// // // //   IconButton,
// // // // } from "@mui/material";
// // // // import EditIcon from "@mui/icons-material/Edit";
// // // // import AddIcon from "@mui/icons-material/Add";
// // // // import ListIcon from "@mui/icons-material/List";
// // // // import DeleteIcon from "@mui/icons-material/Delete"; // Import DeleteIcon


// // // // import {
// // // //   createStory,
// // // //   getAllCategories,
// // // //   getAllStories,
// // // //   getStoryById,
// // // //   addSlidesToStory, // add only new slides
// // // //    deleteStory, // Make sure deleteStory is imported from adminService
// // // // } from "../../../services/adminService"; // Assuming deleteStory is also in adminService

// // // // const CreateStoryForm = () => {
// // // //   // UI mode
// // // //   const [mode, setMode] = useState("list"); // 'list' | 'create' | 'edit'
// // // //   const [editingStoryId, setEditingStoryId] = useState(null);

// // // //   // Form states
// // // //   const [title, setTitle] = useState("");
// // // //   const [summary, setSummary] = useState("");
// // // //   const [category, setCategory] = useState("");
// // // //   const [tags, setTags] = useState("");

// // // //   // For new slides being added from the UI (with captions)
// // // //   // each item: { file: File, caption: string }
// // // //   const [slides, setSlides] = useState([]);

// // // //   // When editing, show already-saved slides (as returned from backend)
// // // //   const [existingSlides, setExistingSlides] = useState([]);

// // // //   // Data
// // // //   const [categories, setCategories] = useState([]);
// // // //   const [stories, setStories] = useState([]);

// // // //   // UI states
// // // //   const [loading, setLoading] = useState(false);
// // // //   const [dataLoading, setDataLoading] = useState(false);
// // // //   const [snackbarOpen, setSnackbarOpen] = useState(false);
// // // //   const [snackbarMessage, setSnackbarMessage] = useState("");
// // // //   const [snackbarSeverity, setSnackbarSeverity] = useState("success");

// // // //   // Helper function to fetch all stories
// // // //   const fetchAllStories = async () => {
// // // //     try {
// // // //       setDataLoading(true);
// // // //       const res = await getAllStories();
// // // //       setStories(res?.data || []);
// // // //     } catch (err) {
// // // //       showMessage("Failed to fetch stories", "error");
// // // //     } finally {
// // // //       setDataLoading(false);
// // // //     }
// // // //   };

// // // //   // Fetch categories once
// // // //   useEffect(() => {
// // // //     (async () => {
// // // //       try {
// // // //         setDataLoading(true);
// // // //         const res = await getAllCategories();
// // // //         setCategories(res?.data || []);
// // // //       } catch (err) {
// // // //         showMessage("Failed to fetch categories", "error");
// // // //       } finally {
// // // //         setDataLoading(false);
// // // //       }
// // // //     })();
// // // //   }, []);

// // // //   // Fetch all stories for list mode
// // // //   useEffect(() => {
// // // //     if (mode !== "list") return;
// // // //     fetchAllStories();
// // // //   }, [mode]);

// // // //   // Fetch a story for edit mode
// // // //   useEffect(() => {
// // // //     if (mode !== "edit" || !editingStoryId) return;
// // // //     (async () => {
// // // //       try {
// // // //         setDataLoading(true);
// // // //         const res = await getStoryById(editingStoryId);
// // // //         const story = res?.data || {};
// // // //         setTitle(story.title || "");
// // // //         setSummary(story.summary || "");
// // // //         // backend may return category as populated object or id
// // // //         setCategory(story.category?._id || story.category || "");
// // // //         setTags(Array.isArray(story.tags) ? story.tags.join(", ") : "");
// // // //         setExistingSlides(story.slides || []);
// // // //         setSlides([]); // user will add NEW slides (with captions) here
// // // //       } catch (err) {
// // // //         showMessage("Failed to fetch story details", "error");
// // // //         setMode("list");
// // // //       } finally {
// // // //         setDataLoading(false);
// // // //       }
// // // //     })();
// // // //   }, [mode, editingStoryId]);

// // // //   const resetForm = () => {
// // // //     setTitle("");
// // // //     setSummary("");
// // // //     setCategory("");
// // // //     setTags("");
// // // //     setSlides([]);
// // // //     setExistingSlides([]);
// // // //     setEditingStoryId(null);
// // // //   };

// // // //   const showMessage = (msg, severity = "success") => {
// // // //     setSnackbarMessage(msg);
// // // //     setSnackbarSeverity(severity);
// // // //     setSnackbarOpen(true);
// // // //   };

// // // //   // Handle selecting files — we wrap each File with a caption field
// // // //   const handleFileChange = (e) => {
// // // //     const files = Array.from(e.target.files || []);
// // // //     const asSlideObjs = files.map((file) => ({ file, caption: "" }));
// // // //     setSlides((prev) => [...prev, ...asSlideObjs]);
// // // //   };

// // // //   // Update caption for a particular new slide
// // // //   const handleCaptionChange = (index, value) => {
// // // //     setSlides((prev) => {
// // // //       const copy = [...prev];
// // // //       copy[index].caption = value;
// // // //       return copy;
// // // //     });
// // // //   };

// // // //   const handleSubmit = async (e) => {
// // // //     e.preventDefault();
// // // //     setLoading(true);

// // // //     try {
// // // //       if (mode === "create") {
// // // //         const fd = new FormData();
// // // //         fd.append("title", title);
// // // //         fd.append("summary", summary);
// // // //         fd.append("category", category);
// // // //         fd.append("tags", JSON.stringify(tags.split(",").map((t) => t.trim()).filter(Boolean)));

// // // //         // append files and matching captions[]
// // // //         slides.forEach((s, idx) => {
// // // //           fd.append("slides", s.file);
// // // //           fd.append(`captions[${idx}]`, s.caption || "");
// // // //         });

// // // //         await createStory(fd);
// // // //         showMessage("Story created successfully!");
// // // //       }

// // // //       if (mode === "edit") {
// // // //         if (slides.length === 0) {
// // // //           showMessage("No new slides selected", "warning");
// // // //           setLoading(false);
// // // //           return;
// // // //         }

// // // //         const fd = new FormData();
// // // //         slides.forEach((s, idx) => {
// // // //           fd.append("slides", s.file);
// // // //           fd.append(`captions[${idx}]`, s.caption || "");
// // // //         });

// // // //         await addSlidesToStory(editingStoryId, fd);
// // // //         showMessage("Slides added successfully!");
// // // //       }

// // // //       resetForm();
// // // //       setMode("list");
// // // //       fetchAllStories(); // Refresh list after create/edit
// // // //     } catch (err) {
// // // //       showMessage(
// // // //         `Failed to ${mode === "create" ? "create" : "update"} story`,
// // // //         "error"
// // // //       );
// // // //     } finally {
// // // //       setLoading(false);
// // // //     }
// // // //   };

// // // //   const handleDeleteStory = async (storyId) => {
// // // //     if (window.confirm("Are you sure you want to delete this story? This action cannot be undone.")) {
// // // //       setLoading(true);
// // // //       try {
// // // //         await deleteStory(storyId);
// // // //         showMessage("Story deleted successfully!", "success");
// // // //         fetchAllStories(); // Refresh the list of stories
// // // //       } catch (err) {
// // // //         showMessage("Failed to delete story.", "error");
// // // //       } finally {
// // // //         setLoading(false);
// // // //       }
// // // //     }
// // // //   };

// // // //   return (
// // // //     <Box sx={{ p: 3, maxWidth: 900, mx: "auto" }}>
// // // //       <Typography variant="h4" align="center" sx={{ mb: 4 }}>
// // // //         Story Management
// // // //       </Typography>

// // // //       {/* mode switch */}
// // // //       <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 4 }}>
// // // //         <Button
// // // //           variant={mode === "list" ? "contained" : "outlined"}
// // // //           onClick={() => {
// // // //             setMode("list");
// // // //             resetForm();
// // // //           }}
// // // //           startIcon={<ListIcon />}
// // // //         >
// // // //           View All Stories
// // // //         </Button>
// // // //         <Button
// // // //           variant={mode === "create" ? "contained" : "outlined"}
// // // //           onClick={() => {
// // // //             setMode("create");
// // // //             resetForm();
// // // //           }}
// // // //           startIcon={<AddIcon />}
// // // //         >
// // // //           Create New Story
// // // //         </Button>
// // // //       </Box>

// // // //       {dataLoading && (
// // // //         <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
// // // //           <CircularProgress />
// // // //           <Typography sx={{ ml: 2 }}>Loading...</Typography>
// // // //         </Box>
// // // //       )}

// // // //       {/* LIST */}
// // // //       {mode === "list" && !dataLoading && (
// // // //         <TableContainer component={Paper}>
// // // //           <Table>
// // // //             <TableHead>
// // // //               <TableRow>
// // // //                 <TableCell>Title</TableCell>
// // // //                 <TableCell>Summary</TableCell>
// // // //                 <TableCell>Category</TableCell>
// // // //                 <TableCell>Tags</TableCell>
// // // //                 <TableCell align="right">Actions</TableCell> {/* Changed to Actions */}
// // // //               </TableRow>
// // // //             </TableHead>
// // // //             <TableBody>
// // // //               {stories.length ? (
// // // //                 stories.map((s) => (
// // // //                   <TableRow key={s._id}>
// // // //                     <TableCell>{s.title}</TableCell>
// // // //                     <TableCell
// // // //                       sx={{
// // // //                         maxWidth: 260,
// // // //                         overflow: "hidden",
// // // //                         textOverflow: "ellipsis",
// // // //                         whiteSpace: "nowrap",
// // // //                       }}
// // // //                     >
// // // //                       {s.summary}
// // // //                     </TableCell>
// // // //                     <TableCell>{s.category?.name || "N/A"}</TableCell>
// // // //                     <TableCell>{Array.isArray(s.tags) ? s.tags.join(", ") : ""}</TableCell>
// // // //                     <TableCell align="right">
// // // //                       <IconButton
// // // //                         color="primary"
// // // //                         onClick={() => {
// // // //                           setEditingStoryId(s._id);
// // // //                           setMode("edit");
// // // //                         }}
// // // //                         aria-label="edit story"
// // // //                       >
// // // //                         <EditIcon />
// // // //                       </IconButton>
// // // //                       <IconButton
// // // //                         color="error" // Use error color for delete action
// // // //                         onClick={() => handleDeleteStory(s._id)}
// // // //                         disabled={loading} // Disable delete button while loading
// // // //                         aria-label="delete story"
// // // //                       >
// // // //                         <DeleteIcon />
// // // //                       </IconButton>
// // // //                     </TableCell>
// // // //                   </TableRow>
// // // //                 ))
// // // //               ) : (
// // // //                 <TableRow>
// // // //                   <TableCell align="center" colSpan={5}>
// // // //                     No stories found. Create one above.
// // // //                   </TableCell>
// // // //                 </TableRow>
// // // //               )}
// // // //             </TableBody>
// // // //           </Table>
// // // //         </TableContainer>
// // // //       )}

// // // //       {/* CREATE / EDIT */}
// // // //       {(mode === "create" || mode === "edit") && !dataLoading && (
// // // //         <Box
// // // //           component="form"
// // // //           onSubmit={handleSubmit}
// // // //           sx={{ mt: 3, p: 3, boxShadow: 3, borderRadius: 2 }}
// // // //         >
// // // //           <Typography variant="h5" align="center" sx={{ mb: 3 }}>
// // // //             {mode === "create" ? "Create Story" : "Add Slides to Story"}
// // // //           </Typography>

// // // //           {mode === "create" && (
// // // //             <>
// // // //               <TextField
// // // //                 label="Title"
// // // //                 fullWidth
// // // //                 value={title}
// // // //                 onChange={(e) => setTitle(e.target.value)}
// // // //                 sx={{ mb: 2 }}
// // // //                 required
// // // //               />
// // // //               <TextField
// // // //                 label="Summary"
// // // //                 fullWidth
// // // //                 multiline
// // // //                 rows={3}
// // // //                 value={summary}
// // // //                 onChange={(e) => setSummary(e.target.value)}
// // // //                 sx={{ mb: 2 }}
// // // //               />
// // // //               <FormControl fullWidth sx={{ mb: 2 }} required>
// // // //                 <InputLabel id="category-label">Category</InputLabel>
// // // //                 <Select
// // // //                   labelId="category-label"
// // // //                   value={category}
// // // //                   label="Category"
// // // //                   onChange={(e) => setCategory(e.target.value)}
// // // //                 >
// // // //                   {categories.length ? (
// // // //                     categories.map((cat) => (
// // // //                       <MenuItem key={cat._id} value={cat._id}>
// // // //                         {cat.name}
// // // //                       </MenuItem>
// // // //                     ))
// // // //                   ) : (
// // // //                     <MenuItem disabled>No categories found</MenuItem>
// // // //                   )}
// // // //                 </Select>
// // // //               </FormControl>
// // // //               <TextField
// // // //                 label="Tags (comma separated)"
// // // //                 fullWidth
// // // //                 value={tags}
// // // //                 onChange={(e) => setTags(e.target.value)}
// // // //                 sx={{ mb: 2 }}
// // // //               />
// // // //             </>
// // // //           )}

// // // //           {/* existing slides when editing */}
// // // //           {mode === "edit" && existingSlides?.length > 0 && (
// // // //             <Box sx={{ mb: 2 }}>
// // // //               <Typography variant="subtitle1">Existing Slides</Typography>
// // // //               <List dense>
// // // //                 {existingSlides.map((sl, idx) => (
// // // //                   <ListItem key={sl._id || idx} sx={{ flexDirection: "column", alignItems: "flex-start" }}>
// // // //                     <ListItemText
// // // //                       primary={`Slide ${idx + 1}`}
// // // //                       secondary={sl.url || sl.mediaUrl || ""}
// // // //                     />
// // // //                     {sl.caption ? (
// // // //                       <Typography variant="body2" color="text.secondary">
// // // //                         Caption: {sl.caption}
// // // //                       </Typography>
// // // //                     ) : null}
// // // //                   </ListItem>
// // // //                 ))}
// // // //               </List>
// // // //             </Box>
// // // //           )}

// // // //           {/* new slides picker */}
// // // //           <Button variant="contained" component="label" sx={{ mb: 2 }}>
// // // //             {mode === "create" ? "Upload Slides" : "Upload New Slides"}
// // // //             <input
// // // //               type="file"
// // // //               hidden
// // // //               multiple
// // // //               accept="image/*,video/*"
// // // //               onChange={handleFileChange}
// // // //             />
// // // //           </Button>

// // // //           {/* new slides with captions */}
// // // //           {slides.length > 0 && (
// // // //             <Box sx={{ mb: 2 }}>
// // // //               <Typography variant="subtitle1">Selected Slides</Typography>
// // // //               <List dense>
// // // //                 {slides.map((s, idx) => (
// // // //                   <ListItem key={idx} sx={{ flexDirection: "column", alignItems: "stretch" }}>
// // // //                     <ListItemText primary={s.file.name} />
// // // //                     <TextField
// // // //                       label="Slide Caption / Summary"
// // // //                       fullWidth
// // // //                       value={s.caption}
// // // //                       onChange={(e) => handleCaptionChange(idx, e.target.value)}
// // // //                       sx={{ mt: 1 }}
// // // //                       placeholder="Enter caption/summary for this slide"
// // // //                     />
// // // //                   </ListItem>
// // // //                 ))}
// // // //               </List>
// // // //             </Box>
// // // //           )}

// // // //           <Button
// // // //             type="submit"
// // // //             variant="contained"
// // // //             fullWidth
// // // //             disabled={loading}
// // // //             startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
// // // //           >
// // // //             {loading
// // // //               ? mode === "create"
// // // //                 ? "Creating..."
// // // //                 : "Adding..."
// // // //               : mode === "create"
// // // //               ? "Create"
// // // //               : "Add Slides"}
// // // //           </Button>

// // // //           <Button
// // // //             variant="outlined"
// // // //             fullWidth
// // // //             sx={{ mt: 2 }}
// // // //             disabled={loading}
// // // //             onClick={() => {
// // // //               setMode("list");
// // // //               resetForm();
// // // //             }}
// // // //           >
// // // //             Back
// // // //           </Button>
// // // //         </Box>
// // // //       )}

// // // //       <Snackbar
// // // //         open={snackbarOpen}
// // // //         autoHideDuration={5000}
// // // //         onClose={() => setSnackbarOpen(false)}
// // // //         anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
// // // //       >
// // // //         <Alert
// // // //           onClose={() => setSnackbarOpen(false)}
// // // //           severity={snackbarSeverity}
// // // //           sx={{ width: "100%" }}
// // // //         >
// // // //           {snackbarMessage}
// // // //         </Alert>
// // // //       </Snackbar>
// // // //     </Box>
// // // //   );
// // // // };

// // // // export default CreateStoryForm;


// // // import React, { useState, useEffect } from "react";
// // // import {
// // //   TextField,
// // //   Button,
// // //   Box,
// // //   Typography,
// // //   MenuItem,
// // //   Select,
// // //   InputLabel,
// // //   FormControl,
// // //   CircularProgress,
// // //   List,
// // //   ListItem,
// // //   ListItemText,
// // //   Snackbar,
// // //   Alert,
// // //   Table,
// // //   TableBody,
// // //   TableCell,
// // //   TableContainer,
// // //   TableHead,
// // //   TableRow,
// // //   Paper,
// // //   IconButton,
// // //   Chip, // Import Chip for tags
// // // } from "@mui/material";
// // // import EditIcon from "@mui/icons-material/Edit";
// // // import AddIcon from "@mui/icons-material/Add";
// // // import ListIcon from "@mui/icons-material/List";
// // // import DeleteIcon from "@mui/icons-material/Delete"; // Import DeleteIcon
// // // import ClearIcon from "@mui/icons-material/Clear"; // For removing tags

// // // import {
// // //   createStory,
// // //   getAllCategories,
// // //   getAllStories,
// // //   getStoryById,
// // //   addSlidesToStory,
// // //   deleteStory,
// // // } from "../../../services/adminService"; // Assuming deleteStory is also in adminService

// // // const CreateStoryForm = () => {
// // //   // UI mode
// // //   const [mode, setMode] = useState("list"); // 'list' | 'create' | 'edit'
// // //   const [editingStoryId, setEditingStoryId] = useState(null);

// // //   // Form states
// // //   const [title, setTitle] = useState("");
// // //   const [summary, setSummary] = useState("");
// // //   const [category, setCategory] = useState("");
// // //   const [tags, setTags] = useState([]); // Changed to array for better tag management
// // //   const [currentTagInput, setCurrentTagInput] = useState(""); // For the tag input field

// // //   // For new slides being added from the UI (with captions)
// // //   // each item: { file: File, caption: string }
// // //   const [slides, setSlides] = useState([]);

// // //   // When editing, show already-saved slides (as returned from backend)
// // //   const [existingSlides, setExistingSlides] = useState([]);

// // //   // Data
// // //   const [categories, setCategories] = useState([]);
// // //   const [stories, setStories] = useState([]);

// // //   // UI states
// // //   const [loading, setLoading] = useState(false);
// // //   const [dataLoading, setDataLoading] = useState(false);
// // //   const [snackbarOpen, setSnackbarOpen] = useState(false);
// // //   const [snackbarMessage, setSnackbarMessage] = useState("");
// // //   const [snackbarSeverity, setSnackbarSeverity] = useState("success");

// // //   // Helper function to fetch all stories
// // //   const fetchAllStories = async () => {
// // //     try {
// // //       setDataLoading(true);
// // //       const res = await getAllStories();
// // //       setStories(res?.data || []);
// // //     } catch (err) {
// // //       showMessage("Failed to fetch stories", "error");
// // //     } finally {
// // //       setDataLoading(false);
// // //     }
// // //   };

// // //   // Fetch categories once
// // //   useEffect(() => {
// // //     (async () => {
// // //       try {
// // //         setDataLoading(true);
// // //         const res = await getAllCategories();
// // //         setCategories(res?.data || []);
// // //       } catch (err) {
// // //         showMessage("Failed to fetch categories", "error");
// // //       } finally {
// // //         setDataLoading(false);
// // //       }
// // //     })();
// // //   }, []);

// // //   // Fetch all stories for list mode
// // //   useEffect(() => {
// // //     if (mode !== "list") return;
// // //     fetchAllStories();
// // //   }, [mode]);

// // //   // Fetch a story for edit mode
// // //   useEffect(() => {
// // //     if (mode !== "edit" || !editingStoryId) return;
// // //     (async () => {
// // //       try {
// // //         setDataLoading(true);
// // //         const res = await getStoryById(editingStoryId);
// // //         const story = res?.data || {};
// // //         setTitle(story.title || "");
// // //         setSummary(story.summary || "");
// // //         // backend may return category as populated object or id
// // //         setCategory(story.category?._id || story.category || "");
// // //         setTags(Array.isArray(story.tags) ? story.tags : []); // Set tags as array
// // //         setExistingSlides(story.slides || []);
// // //         setSlides([]); // user will add NEW slides (with captions) here
// // //       } catch (err) {
// // //         showMessage("Failed to fetch story details", "error");
// // //         setMode("list");
// // //       } finally {
// // //         setDataLoading(false);
// // //       }
// // //     })();
// // //   }, [mode, editingStoryId]);

// // //   const resetForm = () => {
// // //     setTitle("");
// // //     setSummary("");
// // //     setCategory("");
// // //     setTags([]); // Reset tags as array
// // //     setCurrentTagInput(""); // Reset tag input field
// // //     setSlides([]);
// // //     setExistingSlides([]);
// // //     setEditingStoryId(null);
// // //   };

// // //   const showMessage = (msg, severity = "success") => {
// // //     setSnackbarMessage(msg);
// // //     setSnackbarSeverity(severity);
// // //     setSnackbarOpen(true);
// // //   };

// // //   // Handle selecting files — we wrap each File with a caption field
// // //   const handleFileChange = (e) => {
// // //     const files = Array.from(e.target.files || []);
// // //     const asSlideObjs = files.map((file) => ({ file, caption: "" }));
// // //     setSlides((prev) => [...prev, ...asSlideObjs]);
// // //   };

// // //   // Update caption for a particular new slide
// // //   const handleCaptionChange = (index, value) => {
// // //     setSlides((prev) => {
// // //       const copy = [...prev];
// // //       copy[index].caption = value;
// // //       return copy;
// // //     });
// // //   };

// // //   // Handle adding a tag on Enter key press
// // //   const handleAddTag = (e) => {
// // //     if (e.key === "Enter" && currentTagInput.trim()) {
// // //       e.preventDefault(); // Prevent form submission
// // //       const newTag = currentTagInput.trim();
// // //       if (!tags.includes(newTag)) {
// // //         setTags((prevTags) => [...prevTags, newTag]);
// // //       }
// // //       setCurrentTagInput(""); // Clear input field
// // //     }
// // //   };

// // //   // Handle deleting a tag
// // //   const handleDeleteTag = (tagToDelete) => {
// // //     setTags((prevTags) => prevTags.filter((tag) => tag !== tagToDelete));
// // //   };

// // //   const handleSubmit = async (e) => {
// // //     e.preventDefault();
// // //     setLoading(true);

// // //     try {
// // //       if (mode === "create") {
// // //         const fd = new FormData();
// // //         fd.append("title", title);
// // //         fd.append("summary", summary);
// // //         fd.append("category", category);
// // //         fd.append("tags", JSON.stringify(tags)); // Send tags as a JSON stringified array

// // //         // append files and matching captions[]
// // //         slides.forEach((s, idx) => {
// // //           fd.append("slides", s.file);
// // //           fd.append(`captions[${idx}]`, s.caption || "");
// // //         });

// // //         await createStory(fd);
// // //         showMessage("Story created successfully!");
// // //       }

// // //       if (mode === "edit") {
// // //         if (slides.length === 0) {
// // //           showMessage("No new slides selected", "warning");
// // //           setLoading(false);
// // //           return;
// // //         }

// // //         const fd = new FormData();
// // //         slides.forEach((s, idx) => {
// // //           fd.append("slides", s.file);
// // //           fd.append(`captions[${idx}]`, s.caption || "");
// // //         });

// // //         await addSlidesToStory(editingStoryId, fd);
// // //         showMessage("Slides added successfully!");
// // //       }

// // //       resetForm();
// // //       setMode("list");
// // //       fetchAllStories(); // Refresh list after create/edit
// // //     } catch (err) {
// // //       showMessage(
// // //         `Failed to ${mode === "create" ? "create" : "update"} story`,
// // //         "error"
// // //       );
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const handleDeleteStory = async (storyId) => {
// // //     if (window.confirm("Are you sure you want to delete this story? This action cannot be undone.")) {
// // //       setLoading(true);
// // //       try {
// // //         await deleteStory(storyId);
// // //         showMessage("Story deleted successfully!", "success");
// // //         fetchAllStories(); // Refresh the list of stories
// // //       } catch (err) {
// // //         showMessage("Failed to delete story.", "error");
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     }
// // //   };

// // //   return (
// // //     <Box sx={{ p: 3, maxWidth: 900, mx: "auto" }}>
// // //       <Typography variant="h4" align="center" sx={{ mb: 4 }}>
// // //         Story Management
// // //       </Typography>

// // //       {/* mode switch */}
// // //       <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 4 }}>
// // //         <Button
// // //           variant={mode === "list" ? "contained" : "outlined"}
// // //           onClick={() => {
// // //             setMode("list");
// // //             resetForm();
// // //           }}
// // //           startIcon={<ListIcon />}
// // //         >
// // //           View All Stories
// // //         </Button>
// // //         <Button
// // //           variant={mode === "create" ? "contained" : "outlined"}
// // //           onClick={() => {
// // //             setMode("create");
// // //             resetForm();
// // //           }}
// // //           startIcon={<AddIcon />}
// // //         >
// // //           Create New Story
// // //         </Button>
// // //       </Box>

// // //       {dataLoading && (
// // //         <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
// // //           <CircularProgress />
// // //           <Typography sx={{ ml: 2 }}>Loading...</Typography>
// // //         </Box>
// // //       )}

// // //       {/* LIST */}
// // //       {mode === "list" && !dataLoading && (
// // //         <TableContainer component={Paper}>
// // //           <Table>
// // //             <TableHead>
// // //               <TableRow>
// // //                 <TableCell>Title</TableCell>
// // //                 <TableCell>Summary</TableCell>
// // //                 <TableCell>Category</TableCell>
// // //                 <TableCell>Tags</TableCell>
// // //                 <TableCell align="right">Actions</TableCell>
// // //               </TableRow>
// // //             </TableHead>
// // //             <TableBody>
// // //               {stories.length ? (
// // //                 stories.map((s) => (
// // //                   <TableRow key={s._id}>
// // //                     <TableCell>{s.title}</TableCell>
// // //                     <TableCell
// // //                       sx={{
// // //                         maxWidth: 260,
// // //                         overflow: "hidden",
// // //                         textOverflow: "ellipsis",
// // //                         whiteSpace: "nowrap",
// // //                       }}
// // //                     >
// // //                       {s.summary}
// // //                     </TableCell>
// // //                     <TableCell>{s.category?.name || "N/A"}</TableCell>
// // //                     <TableCell>
// // //                         {Array.isArray(s.tags) ? s.tags.join(", ") : ""}
// // //                     </TableCell>
// // //                     <TableCell align="right">
// // //                       <IconButton
// // //                         color="primary"
// // //                         onClick={() => {
// // //                           setEditingStoryId(s._id);
// // //                           setMode("edit");
// // //                         }}
// // //                         aria-label="edit story"
// // //                       >
// // //                         <EditIcon />
// // //                       </IconButton>
// // //                       <IconButton
// // //                         color="error"
// // //                         onClick={() => handleDeleteStory(s._id)}
// // //                         disabled={loading}
// // //                         aria-label="delete story"
// // //                       >
// // //                         <DeleteIcon />
// // //                       </IconButton>
// // //                     </TableCell>
// // //                   </TableRow>
// // //                 ))
// // //               ) : (
// // //                 <TableRow>
// // //                   <TableCell align="center" colSpan={5}>
// // //                     No stories found. Create one above.
// // //                   </TableCell>
// // //                 </TableRow>
// // //               )}
// // //             </TableBody>
// // //           </Table>
// // //         </TableContainer>
// // //       )}

// // //       {/* CREATE / EDIT */}
// // //       {(mode === "create" || mode === "edit") && !dataLoading && (
// // //         <Box
// // //           component="form"
// // //           onSubmit={handleSubmit}
// // //           sx={{ mt: 3, p: 3, boxShadow: 3, borderRadius: 2 }}
// // //         >
// // //           <Typography variant="h5" align="center" sx={{ mb: 3 }}>
// // //             {mode === "create" ? "Create Story" : "Add Slides to Story"}
// // //           </Typography>

// // //           {mode === "create" && (
// // //             <>
// // //               <TextField
// // //                 label="Title"
// // //                 fullWidth
// // //                 value={title}
// // //                 onChange={(e) => setTitle(e.target.value)}
// // //                 sx={{ mb: 2 }}
// // //                 required
// // //               />
// // //               <TextField
// // //                 label="Summary"
// // //                 fullWidth
// // //                 multiline
// // //                 rows={3}
// // //                 value={summary}
// // //                 onChange={(e) => setSummary(e.target.value)}
// // //                 sx={{ mb: 2 }}
// // //               />
// // //               <FormControl fullWidth sx={{ mb: 2 }} required>
// // //                 <InputLabel id="category-label">Category</InputLabel>
// // //                 <Select
// // //                   labelId="category-label"
// // //                   value={category}
// // //                   label="Category"
// // //                   onChange={(e) => setCategory(e.target.value)}
// // //                 >
// // //                   {categories.length ? (
// // //                     categories.map((cat) => (
// // //                       <MenuItem key={cat._id} value={cat._id}>
// // //                         {cat.name}
// // //                       </MenuItem>
// // //                     ))
// // //                   ) : (
// // //                     <MenuItem disabled>No categories found</MenuItem>
// // //                   )}
// // //                 </Select>
// // //               </FormControl>
              
// // //               {/* New Tag Input */}
// // //               <TextField
// // //                 label="Add Tags (Type and press Enter)"
// // //                 fullWidth
// // //                 value={currentTagInput}
// // //                 onChange={(e) => setCurrentTagInput(e.target.value)}
// // //                 onKeyDown={handleAddTag}
// // //                 sx={{ mb: 2 }}
// // //               />
// // //               <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
// // //                 {tags.map((tag) => (
// // //                   <Chip
// // //                     key={tag}
// // //                     label={tag}
// // //                     onDelete={() => handleDeleteTag(tag)}
// // //                     deleteIcon={<ClearIcon />}
// // //                     color="primary"
// // //                     variant="outlined"
// // //                   />
// // //                 ))}
// // //               </Box>
// // //             </>
// // //           )}

// // //           {/* existing slides when editing */}
// // //           {mode === "edit" && existingSlides?.length > 0 && (
// // //             <Box sx={{ mb: 2 }}>
// // //               <Typography variant="subtitle1">Existing Slides</Typography>
// // //               <List dense>
// // //                 {existingSlides.map((sl, idx) => (
// // //                   <ListItem key={sl._id || idx} sx={{ flexDirection: "column", alignItems: "flex-start" }}>
// // //                     <ListItemText
// // //                       primary={`Slide ${idx + 1}`}
// // //                       secondary={sl.url || sl.mediaUrl || ""}
// // //                     />
// // //                     {sl.caption ? (
// // //                       <Typography variant="body2" color="text.secondary">
// // //                         Caption: {sl.caption}
// // //                       </Typography>
// // //                     ) : null}
// // //                   </ListItem>
// // //                 ))}
// // //               </List>
// // //             </Box>
// // //           )}

// // //           {/* new slides picker */}
// // //           <Button variant="contained" component="label" sx={{ mb: 2 }}>
// // //             {mode === "create" ? "Upload Slides" : "Upload New Slides"}
// // //             <input
// // //               type="file"
// // //               hidden
// // //               multiple
// // //               accept="image/*,video/*"
// // //               onChange={handleFileChange}
// // //             />
// // //           </Button>

// // //           {/* new slides with captions */}
// // //           {slides.length > 0 && (
// // //             <Box sx={{ mb: 2 }}>
// // //               <Typography variant="subtitle1">Selected Slides</Typography>
// // //               <List dense>
// // //                 {slides.map((s, idx) => (
// // //                   <ListItem key={idx} sx={{ flexDirection: "column", alignItems: "stretch" }}>
// // //                     <ListItemText primary={s.file.name} />
// // //                     <TextField
// // //                       label="Slide Caption / Summary"
// // //                       fullWidth
// // //                       value={s.caption}
// // //                       onChange={(e) => handleCaptionChange(idx, e.target.value)}
// // //                       sx={{ mt: 1 }}
// // //                       placeholder="Enter caption/summary for this slide"
// // //                     />
// // //                   </ListItem>
// // //                 ))}
// // //               </List>
// // //             </Box>
// // //           )}

// // //           <Button
// // //             type="submit"
// // //             variant="contained"
// // //             fullWidth
// // //             disabled={loading}
// // //             startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
// // //           >
// // //             {loading
// // //               ? mode === "create"
// // //                 ? "Creating..."
// // //                 : "Adding..."
// // //               : mode === "create"
// // //               ? "Create"
// // //               : "Add Slides"}
// // //           </Button>

// // //           <Button
// // //             variant="outlined"
// // //             fullWidth
// // //             sx={{ mt: 2 }}
// // //             disabled={loading}
// // //             onClick={() => {
// // //               setMode("list");
// // //               resetForm();
// // //             }}
// // //           >
// // //             Back
// // //           </Button>
// // //         </Box>
// // //       )}

// // //       <Snackbar
// // //         open={snackbarOpen}
// // //         autoHideDuration={5000}
// // //         onClose={() => setSnackbarOpen(false)}
// // //         anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
// // //       >
// // //         <Alert
// // //           onClose={() => setSnackbarOpen(false)}
// // //           severity={snackbarSeverity}
// // //           sx={{ width: "100%" }}
// // //         >
// // //           {snackbarMessage}
// // //         </Alert>
// // //       </Snackbar>
// // //     </Box>
// // //   );
// // // };

// // // export default CreateStoryForm;




// // // comlter workinfg ocde bhia 
 


// // import React, { useState, useEffect } from "react";
// // import {
// //   TextField,
// //   Button,
// //   Box,
// //   Typography,
// //   MenuItem,
// //   Select,
// //   InputLabel,
// //   FormControl,
// //   CircularProgress,
// //   List,
// //   ListItem,
// //   ListItemText,
// //   Snackbar,
// //   Alert,
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   Paper,
// //   IconButton,
// //   Chip,
// // } from "@mui/material";
// // import EditIcon from "@mui/icons-material/Edit";
// // import AddIcon from "@mui/icons-material/Add";
// // import ListIcon from "@mui/icons-material/List";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import ClearIcon from "@mui/icons-material/Clear";

// // import {
// //   createStory,
// //   getAllCategories,
// //   getAllStories,
// //   getStoryById,
// //   addSlidesToStory,
// //   deleteStory,
// // } from "../../../services/adminService";

// // const CreateStoryForm = () => {
// //   const [mode, setMode] = useState("list"); // list | create | edit
// //   const [editingStoryId, setEditingStoryId] = useState(null);

// //   const [title, setTitle] = useState("");
// //   const [summary, setSummary] = useState("");
// //   const [category, setCategory] = useState("");
// //   const [tags, setTags] = useState([]);
// //   const [currentTagInput, setCurrentTagInput] = useState("");

// //   const [slides, setSlides] = useState([]); // New slides
// //   const [existingSlides, setExistingSlides] = useState([]); // When editing

// //   const [categories, setCategories] = useState([]);
// //   const [stories, setStories] = useState([]);

// //   const [loading, setLoading] = useState(false);
// //   const [dataLoading, setDataLoading] = useState(false);

// //   const [snackbarOpen, setSnackbarOpen] = useState(false);
// //   const [snackbarMessage, setSnackbarMessage] = useState("");
// //   const [snackbarSeverity, setSnackbarSeverity] = useState("success");

// //   // Fetch categories
// //   useEffect(() => {
// //     (async () => {
// //       try {
// //         setDataLoading(true);
// //         const res = await getAllCategories();
// //         setCategories(res?.data || []);
// //       } catch {
// //         showMessage("Failed to fetch categories", "error");
// //       } finally {
// //         setDataLoading(false);
// //       }
// //     })();
// //   }, []);

// //   // Fetch stories
// //   const fetchAllStories = async () => {
// //     try {
// //       setDataLoading(true);
// //       const res = await getAllStories();
// //       setStories(res?.data || []);
// //     } catch {
// //       showMessage("Failed to fetch stories", "error");
// //     } finally {
// //       setDataLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (mode === "list") fetchAllStories();
// //   }, [mode]);

// //   // Fetch story details for editing
// //   useEffect(() => {
// //     if (mode !== "edit" || !editingStoryId) return;
// //     (async () => {
// //       try {
// //         setDataLoading(true);
// //         const res = await getStoryById(editingStoryId);
// //         const story = res?.data || {};
// //         setTitle(story.title || "");
// //         setSummary(story.summary || "");
// //         setCategory(story.category?._id || story.category || "");
// //         setTags(Array.isArray(story.tags) ? story.tags : []);
// //         setExistingSlides(story.slides || []);
// //         setSlides([]);
// //       } catch {
// //         showMessage("Failed to fetch story details", "error");
// //         setMode("list");
// //       } finally {
// //         setDataLoading(false);
// //       }
// //     })();
// //   }, [mode, editingStoryId]);

// //   const resetForm = () => {
// //     setTitle("");
// //     setSummary("");
// //     setCategory("");
// //     setTags([]);
// //     setCurrentTagInput("");
// //     setSlides([]);
// //     setExistingSlides([]);
// //     setEditingStoryId(null);
// //   };

// //   const showMessage = (msg, severity = "success") => {
// //     setSnackbarMessage(msg);
// //     setSnackbarSeverity(severity);
// //     setSnackbarOpen(true);
// //   };

// //   const handleFileChange = (e) => {
// //     const files = Array.from(e.target.files || []);
// //     setSlides((prev) => [...prev, ...files.map((f) => ({ file: f, caption: "" }))]);
// //   };

// //   const handleCaptionChange = (index, value) => {
// //     setSlides((prev) => {
// //       const copy = [...prev];
// //       copy[index].caption = value;
// //       return copy;
// //     });
// //   };

// //   const handleAddTag = (e) => {
// //     if (e.key === "Enter" && currentTagInput.trim()) {
// //       e.preventDefault();
// //       if (!tags.includes(currentTagInput.trim()))
// //         setTags((prev) => [...prev, currentTagInput.trim()]);
// //       setCurrentTagInput("");
// //     }
// //   };

// //   const handleDeleteTag = (tag) => {
// //     setTags((prev) => prev.filter((t) => t !== tag));
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setLoading(true);

// //     try {
// //       if (mode === "create") {
// //         const fd = new FormData();
// //         fd.append("title", title);
// //         fd.append("summary", summary);
// //         fd.append("category", category);
// //         fd.append("tags", JSON.stringify(tags));
// //         slides.forEach((s, idx) => {
// //           fd.append("slides", s.file);
// //           fd.append(`captions[${idx}]`, s.caption || "");
// //         });
// //         await createStory(fd);
// //         showMessage("Story created successfully!");
// //       }

// //       if (mode === "edit") {
// //         if (slides.length === 0) {
// //           showMessage("No new slides selected", "warning");
// //           setLoading(false);
// //           return;
// //         }
// //         const fd = new FormData();
// //         slides.forEach((s, idx) => {
// //           fd.append("slides", s.file);
// //           fd.append(`captions[${idx}]`, s.caption || "");
// //         });
// //         await addSlidesToStory(editingStoryId, fd);
// //         showMessage("Slides added successfully!");
// //       }

// //       resetForm();
// //       setMode("list");
// //       fetchAllStories();
// //     } catch {
// //       showMessage(`Failed to ${mode === "create" ? "create" : "update"} story`, "error");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleDeleteStory = async (id) => {
// //     if (!window.confirm("Are you sure you want to delete this story?")) return;
// //     setLoading(true);
// //     try {
// //       await deleteStory(id);
// //       showMessage("Story deleted successfully!");
// //       fetchAllStories();
// //     } catch {
// //       showMessage("Failed to delete story.", "error");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   return (
// //     <Box sx={{  maxWidth: 1000, mx: "auto" }}>
// //       <Typography variant="h6" align="center" sx={{ mb: 4 }}>
// //         Story Management
// //       </Typography>

// //       {/* Mode Switch Buttons */}
// //       <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 4, flexWrap: "wrap" }}>
// //         <Button
// //           variant={mode === "list" ? "contained" : "outlined"}
// //           startIcon={<ListIcon />}
// //           onClick={() => {
// //             setMode("list");
// //             resetForm();
// //           }}
// //         >
// //           View Stories
// //         </Button>
// //         <Button
// //           variant={mode === "create" ? "contained" : "outlined"}
// //           startIcon={<AddIcon />}
// //           onClick={() => {
// //             setMode("create");
// //             resetForm();
// //           }}
// //         >
// //           Create Story
// //         </Button>
// //       </Box>

// //       {dataLoading && (
// //         <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
// //           <CircularProgress />
// //           <Typography sx={{ ml: 2 }}>Loading...</Typography>
// //         </Box>
// //       )}

// //       {/* LIST MODE */}
// //       {/* {mode === "list" && !dataLoading && (
// //         <TableContainer component={Paper}>
// //           <Table>
// //             <TableHead>
// //               <TableRow>
// //                 <TableCell>Title</TableCell>
// //                 <TableCell>Summary</TableCell>
// //                 <TableCell>Category</TableCell>
// //                 <TableCell>Tags</TableCell>
// //                 <TableCell align="right">Actions</TableCell>
// //               </TableRow>
// //             </TableHead>
// //             <TableBody>
// //               {stories.length ? (
// //                 stories.map((s) => (
// //                   <TableRow key={s._id} hover>
// //                     <TableCell>{s.title}</TableCell>
// //                     <TableCell
// //                       sx={{
// //                         maxWidth: 250,
// //                         overflow: "hidden",
// //                         textOverflow: "ellipsis",
// //                         whiteSpace: "nowrap",
// //                       }}
// //                     >
// //                       {s.summary}
// //                     </TableCell>
// //                     <TableCell>{s.category?.name || "N/A"}</TableCell>
// //                     <TableCell>{Array.isArray(s.tags) ? s.tags.join(", ") : ""}</TableCell>
// //                     <TableCell align="right">
// //                       <IconButton
// //                         color="primary"
// //                         onClick={() => {
// //                           setEditingStoryId(s._id);
// //                           setMode("edit");
// //                         }}
// //                       >
// //                         <EditIcon />
// //                       </IconButton>
// //                       <IconButton
// //                         color="error"
// //                         onClick={() => handleDeleteStory(s._id)}
// //                         disabled={loading}
// //                       >
// //                         <DeleteIcon />
// //                       </IconButton>
// //                     </TableCell>
// //                   </TableRow>
// //                 ))
// //               ) : (
// //                 <TableRow>
// //                   <TableCell colSpan={5} align="center">
// //                     No stories found. Create one above.
// //                   </TableCell>
// //                 </TableRow>
// //               )}
// //             </TableBody>
// //           </Table>
// //         </TableContainer>
// //       )} */}
// //         {mode === "list" && !dataLoading && (
// //   <TableContainer component={Paper}>
// //     <Table>
// //       <TableHead>
// //         <TableRow>
          
// //            <TableCell>#</TableCell> 
// //               <TableCell>Slide</TableCell> {/* Column for media */}
// //           <TableCell>Title</TableCell>
// //           <TableCell>Summary</TableCell>
// //           <TableCell>Category</TableCell>
// //           <TableCell>Tags</TableCell>
        
// //           <TableCell align="right">Actions</TableCell>
// //         </TableRow>
// //       </TableHead>
// //       <TableBody>
// //         {stories.length ? (
// //           stories.map((story,idx) => (
// //             <TableRow key={story._id} hover>
              
// //                   <TableCell> {idx + 1}</TableCell>
// //                  <TableCell>
// //                 {story.slides && story.slides.length > 0 ? (
// //                   story.slides[0].mediaType === "image" ? (
// //                     <img
// //                       src={story.slides[0].mediaUrl}
// //                       alt={`Slide 1 of ${story.title}`}
// //                       style={{ width: 100, height: 60, objectFit: "cover", borderRadius: 4 }}
// //                     />
// //                   ) : (
// //                        <video
// //         src={story.slides[0].mediaUrl}
// //         style={{ width: 100, height: 60, borderRadius: 8 }}
// //         autoPlay
// //         muted
// //         loop
// //         playsInline
// //       />
// //                   )
// //                 ) : (
// //                   "No media"
// //                 )}
// //               </TableCell>
// //               <TableCell>{story.title}</TableCell>
// //               <TableCell
// //                 sx={{
// //                   maxWidth: 250,
// //                   overflow: "hidden",
// //                   textOverflow: "ellipsis",
// //                   whiteSpace: "nowrap",
// //                 }}
// //               >
// //                 {story.summary}
// //               </TableCell>
// //               <TableCell>{story.category?.name || "N/A"}</TableCell>
// //               <TableCell>{Array.isArray(story.tags) ? story.tags.join(", ") : ""}</TableCell>
             
// //               <TableCell align="right">
// //                 <IconButton
// //                   color="primary"
// //                   onClick={() => {
// //                     setEditingStoryId(story._id);
// //                     setMode("edit");
// //                   }}
// //                 >
// //                   <EditIcon />
// //                 </IconButton>
// //                 <IconButton
// //                   color="error"
// //                   onClick={() => handleDeleteStory(story._id)}
// //                   disabled={loading}
// //                 >
// //                   <DeleteIcon />
// //                 </IconButton>
// //               </TableCell>
// //             </TableRow>
// //           ))
// //         ) : (
// //           <TableRow>
// //             <TableCell colSpan={6} align="center">
// //               No stories found. Create one above.
// //             </TableCell>
// //           </TableRow>
// //         )}
// //       </TableBody>
// //     </Table>
// //   </TableContainer>
// // )}


// //       {/* CREATE / EDIT FORM */}
// //       {(mode === "create" || mode === "edit") && !dataLoading && (
// //         <Box
// //           component="form"
// //           onSubmit={handleSubmit}
// //           sx={{ mt: 3, p: 3, boxShadow: 3, borderRadius: 2 }}
// //         >
// //           <Typography variant="h5" align="center" sx={{ mb: 3 }}>
// //             {mode === "create" ? "Create Story" : "Add Slides to Story"}
// //           </Typography>

// //           {mode === "create" && (
// //             <>
// //               <TextField
// //                 label="Title"
// //                 fullWidth
// //                 value={title}
// //                 onChange={(e) => setTitle(e.target.value)}
// //                 sx={{ mb: 2 }}
// //                 required
// //               />
// //               <TextField
// //                 label="Summary"
// //                 fullWidth
// //                 multiline
// //                 rows={3}
// //                 value={summary}
// //                 onChange={(e) => setSummary(e.target.value)}
// //                 sx={{ mb: 2 }}
// //               />
// //               <FormControl fullWidth sx={{ mb: 2 }} required>
// //                 <InputLabel>Category</InputLabel>
// //                 <Select value={category} onChange={(e) => setCategory(e.target.value)}>
// //                   {categories.length ? (
// //                     categories.map((cat) => (
// //                       <MenuItem key={cat._id} value={cat._id}>
// //                         {cat.name}
// //                       </MenuItem>
// //                     ))
// //                   ) : (
// //                     <MenuItem disabled>No categories found</MenuItem>
// //                   )}
// //                 </Select>
// //               </FormControl>

// //               {/* Tag Input */}
// //               <TextField
// //                 label="Add Tags (press Enter)"
// //                 fullWidth
// //                 value={currentTagInput}
// //                 onChange={(e) => setCurrentTagInput(e.target.value)}
// //                 onKeyDown={handleAddTag}
// //                 sx={{ mb: 2 }}
// //               />
// //               <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
// //                 {tags.map((tag) => (
// //                   <Chip
// //                     key={tag}
// //                     label={tag}
// //                     onDelete={() => handleDeleteTag(tag)}
// //                     deleteIcon={<ClearIcon />}
// //                     color="primary"
// //                     variant="outlined"
// //                   />
// //                 ))}
// //               </Box>
// //             </>
// //           )}

// //         {/* Existing slides when editing */}
// // {mode === "edit" && existingSlides.length > 0 && (
// //   <Box sx={{ mb: 2 }}>
// //     <Typography variant="subtitle1" sx={{ mb: 1 }}>
// //       Existing Slides
// //     </Typography>
// //     <List dense>
// //       {existingSlides.map((sl, idx) => (
// //         <ListItem
// //           key={sl._id || idx}
// //           sx={{ flexDirection: "column", alignItems: "flex-start", mb: 2 }}
// //         >
// //           <ListItemText primary={`Slide ${idx + 1}`} />
// //           {/* Display media */}
// //           {sl.mediaType === "image" ? (
// //             <img
// //               src={sl.mediaUrl || sl.url}
// //               alt={`Slide ${idx + 1}`}
// //               style={{ width: 250, height: 120, objectFit: "cover", borderRadius: 4 }}
// //             />
// //           ) : sl.mediaType === "video" ? (
         

// //             <video
// //           src={sl.mediaUrl || sl.url}
// //         style={{ width: 250, height: 140, borderRadius: 8 }}
// //         autoPlay
// //         muted
// //         loop
// //         playsInline
// //       />
// //           ) : (
// //             <Typography variant="body2" color="text.secondary">
// //               Media not supported
// //             </Typography>
// //           )}

// //           {/* Caption */}
// //           {sl.caption && (
// //             <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
// //               Caption: {sl.caption}
// //             </Typography>
// //           )}
// //         </ListItem>
// //       ))}
// //     </List>
// //   </Box>
// // )}


// //           {/* File Upload */}
// //           <Button variant="contained" component="label" sx={{ mb: 2 }}>
// //             {mode === "create" ? "Upload Slides" : "Upload New Slides"}
// //             <input
// //               type="file"
// //               hidden
// //               multiple
// //               accept="image/*,video/*"
// //               onChange={handleFileChange}
// //             />
// //           </Button>

// //           {/* New slides list */}
// //           {slides.length > 0 && (
// //             <Box sx={{ mb: 2 }}>
// //               <Typography variant="subtitle1">Selected Slides</Typography>
// //               <List dense>
// //                 {slides.map((s, idx) => (
// //                   <ListItem
// //                     key={idx}
// //                     sx={{ flexDirection: "column", alignItems: "stretch" }}
// //                   >
// //                     <ListItemText primary={s.file.name} />
// //                     <TextField
// //                       label="Slide Caption / Summary"
// //                       fullWidth
// //                       value={s.caption}
// //                       onChange={(e) => handleCaptionChange(idx, e.target.value)}
// //                       sx={{ mt: 1 }}
// //                       placeholder="Enter caption/summary"
// //                     />
// //                   </ListItem>
// //                 ))}
// //               </List>
// //             </Box>
// //           )}

// //           <Button
// //             type="submit"
// //             variant="contained"
// //             fullWidth
// //             disabled={loading}
// //             startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
// //           >
// //             {loading ? (mode === "create" ? "Creating..." : "Adding...") : mode === "create" ? "Create" : "Add Slides"}
// //           </Button>

// //           <Button
// //             variant="outlined"
// //             fullWidth
// //             sx={{ mt: 2 }}
// //             disabled={loading}
// //             onClick={() => {
// //               setMode("list");
// //               resetForm();
// //             }}
// //           >
// //             Back
// //           </Button>
// //         </Box>
// //       )}

// //       <Snackbar
// //         open={snackbarOpen}
// //         autoHideDuration={5000}
// //         onClose={() => setSnackbarOpen(false)}
// //         anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
// //       >
// //         <Alert
// //           onClose={() => setSnackbarOpen(false)}
// //           severity={snackbarSeverity}
// //           sx={{ width: "100%" }}
// //         >
// //           {snackbarMessage}
// //         </Alert>
// //       </Snackbar>
// //     </Box>
// //   );
// // };

// // export default CreateStoryForm;
        

// import React, { useState, useEffect } from "react";
// import {
//   TextField,
//   Button,
//   Box,
//   Typography,
//   MenuItem,
//   Select,
//   InputLabel,
//   FormControl,
//   CircularProgress,
//   List,
//   ListItem,
//   ListItemText,
//   Snackbar,
//   Alert,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
//   Chip,
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import AddIcon from "@mui/icons-material/Add";
// import ListIcon from "@mui/icons-material/List";
// import DeleteIcon from "@mui/icons-material/Delete";
// import ClearIcon from "@mui/icons-material/Clear";
// import LinkIcon from "@mui/icons-material/Link"; // For general external links
// import CloseIcon from "@mui/icons-material/Close"; // For removing slides
// import YouTubeIcon from '@mui/icons-material/YouTube'; // For YouTube specific icon

// import {
//   createStory,
//   getAllCategories,
//   getAllStories,
//   getStoryById,
//   addSlidesToStory,
//   deleteStory,
// } from "../../../services/adminService"; // Ensure this path is correct

// // Helper to extract YouTube video ID from various YouTube URLs
// const getYouTubeVideoId = (url) => {
//   if (!url) return null;
//   const regExp =
//     /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
//   const match = url.match(regExp);
//   // Check for the length of the matched ID (YouTube IDs are 11 characters)
//   return (match && match[2] && match[2].length === 11) ? match[2] : null;
// };

// // Helper to get YouTube thumbnail URL
// const getYouTubeThumbnail = (videoId) => {
//   if (!videoId) return null;
//   // Using 'mqdefault' for medium quality thumbnail, 'hqdefault' for high quality
//   return `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
// };

// const CreateStoryForm = () => {
//   const [mode, setMode] = useState("list"); // list | create | edit
//   const [editingStoryId, setEditingStoryId] = useState(null);

//   const [title, setTitle] = useState("");
//   const [summary, setSummary] = useState("");
//   const [category, setCategory] = useState("");
//   const [tags, setTags] = useState([]);
//   const [currentTagInput, setCurrentTagInput] = useState("");

//   // New state to manage both file uploads and external links
//   const [newSlides, setNewSlides] = useState([]); // [{ type: 'file', file: File, caption: '' }, { type: 'external', url: '', caption: '' }]
//   const [currentExternalUrl, setCurrentExternalUrl] = useState("");
//   const [currentExternalCaption, setCurrentExternalCaption] = useState("");

//   const [existingSlides, setExistingSlides] = useState([]); // When editing, existing slides from the story

//   const [categories, setCategories] = useState([]);
//   const [stories, setStories] = useState([]);

//   const [loading, setLoading] = useState(false); // General loading state for actions
//   const [dataLoading, setDataLoading] = useState(false); // Loading state for fetching data

//   // States for Snackbar feedback
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");

//   // Helper function to show Snackbar messages
//   const showMessage = (msg, severity = "success") => {
//     setSnackbarMessage(msg);
//     setSnackbarSeverity(severity);
//     setSnackbarOpen(true);
//   };

//   // Fetch categories on component mount
//   useEffect(() => {
//     (async () => {
//       try {
//         setDataLoading(true);
//         const res = await getAllCategories();
//         setCategories(res?.data || []);
//       } catch {
//         showMessage("Failed to fetch categories", "error");
//       } finally {
//         setDataLoading(false);
//       }
//     })();
//   }, []);

//   // Fetch stories when mode changes to 'list'
//   const fetchAllStories = async () => {
//     try {
//       setDataLoading(true);
//       const res = await getAllStories();
//       setStories(res?.data || []);
//     } catch {
//       showMessage("Failed to fetch stories", "error");
//     } finally {
//       setDataLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (mode === "list") fetchAllStories();
//   }, [mode]);

//   // Fetch story details for editing
//   useEffect(() => {
//     if (mode !== "edit" || !editingStoryId) return;
//     (async () => {
//       try {
//         setDataLoading(true);
//         const res = await getStoryById(editingStoryId);
//         const story = res?.data || {};
//         console.log("Fetched Story for editing:", story); // Debug log
//         setTitle(story.title || "");
//         setSummary(story.summary || "");
//         setCategory(story.category?._id || story.category || "");
//         setTags(Array.isArray(story.tags) ? story.tags : []);
//         setExistingSlides(story.slides || []); // Populate existing slides
//         setNewSlides([]); // Clear new slides when loading an existing story
//       } catch (error) {
//         console.error("Error fetching story details:", error); // Debug log
//         showMessage("Failed to fetch story details", "error");
//         setMode("list"); // Fallback to list mode on error
//       } finally {
//         setDataLoading(false);
//       }
//     })();
//   }, [mode, editingStoryId]);

//   // Reset form fields
//   const resetForm = () => {
//     setTitle("");
//     setSummary("");
//     setCategory("");
//     setTags([]);
//     setCurrentTagInput("");
//     setNewSlides([]); // Reset new slides (files + external links)
//     setCurrentExternalUrl("");
//     setCurrentExternalCaption("");
//     setExistingSlides([]); // Reset existing slides
//     setEditingStoryId(null);
//   };

//   // Handle file input change
//   const handleFileChange = (e) => {
//     const files = Array.from(e.target.files || []);
//     setNewSlides((prev) => [
//       ...prev,
//       ...files.map((f) => ({ type: "file", file: f, caption: "" })),
//     ]);
//   };

//   // Handle adding an external link
//   const handleAddExternalLink = () => {
//     if (currentExternalUrl.trim()) {
//       setNewSlides((prev) => [
//         ...prev,
//         {
//           type: "external",
//           url: currentExternalUrl.trim(),
//           caption: currentExternalCaption.trim(),
//         },
//       ]);
//       setCurrentExternalUrl("");
//       setCurrentExternalCaption("");
//     } else {
//       showMessage("External URL cannot be empty.", "warning");
//     }
//   };

//   // Handle caption change for a specific slide (newly added)
//   const handleNewSlideCaptionChange = (index, value) => {
//     setNewSlides((prev) => {
//       const copy = [...prev];
//       copy[index].caption = value;
//       return copy;
//     });
//   };

//   // Handle removing a newly added slide
//   const handleRemoveNewSlide = (index) => {
//     setNewSlides((prev) => prev.filter((_, i) => i !== index));
//   };

//   // Handle adding tags
//   const handleAddTag = (e) => {
//     if (e.key === "Enter" && currentTagInput.trim()) {
//       e.preventDefault();
//       if (!tags.includes(currentTagInput.trim()))
//         setTags((prev) => [...prev, currentTagInput.trim()]);
//       setCurrentTagInput("");
//     }
//   };

//   // Handle deleting tags
//   const handleDeleteTag = (tag) => {
//     setTags((prev) => prev.filter((t) => t !== tag));
//   };

//   // Handle form submission (Create or Add Slides)
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const fd = new FormData();
//       const fileSlides = newSlides.filter(s => s.type === 'file');
//       const externalSlidesData = newSlides.filter(s => s.type === 'external').map(s => ({
//         mediaUrl: s.url,
//         caption: s.caption,
//       }));

//       // Append general story data only for create mode
//       if (mode === "create") {
//         if (!title || !category) {
//           showMessage("Title and Category are required to create a story.", "warning");
//           setLoading(false);
//           return;
//         }
//         fd.append("title", title);
//         fd.append("summary", summary);
//         fd.append("category", category);
//         fd.append("tags", JSON.stringify(tags));
//       }

//       // Append file slides and their captions
//       fileSlides.forEach((s, idx) => {
//         fd.append("slides", s.file); // 'slides' is the field for file uploads on backend
//         fd.append(`captions[${idx}]`, s.caption || ""); // Captions array for files
//       });

//       // Append external slides as a JSON string
//       if (externalSlidesData.length > 0) {
//         fd.append("externalSlides", JSON.stringify(externalSlidesData));
//       }


//       if (mode === "create") {
//         await createStory(fd);
//         showMessage("Story created successfully!");
//       }

//       if (mode === "edit") {
//         // In edit mode, we only add new slides (files or external links).
//         if (fileSlides.length === 0 && externalSlidesData.length === 0) {
//           showMessage("No new slides (files or external links) selected to add", "warning");
//           setLoading(false);
//           return;
//         }
//         await addSlidesToStory(editingStoryId, fd);
//         showMessage("Slides added successfully!");
//       }

//       resetForm();
//       setMode("list");
//       fetchAllStories();
//     } catch (error) {
//       console.error("Submission error:", error); // Debug log
//       showMessage(`Failed to ${mode === "create" ? "create" : "update"} story`, "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle deleting a story
//   const handleDeleteStory = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this story?")) return;
//     setLoading(true);
//     try {
//       await deleteStory(id);
//       showMessage("Story deleted successfully!");
//       fetchAllStories();
//     } catch (error) {
//       console.error("Error deleting story:", error); // Debug log
//       showMessage("Failed to delete story.", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box sx={{ maxWidth: 1000, mx: "auto" }}>
//       <Typography variant="h6" align="center" sx={{ mb: 4 }}>
//         Story Management
//       </Typography>

//       {/* Mode Switch Buttons */}
//       <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 4, flexWrap: "wrap" }}>
//         <Button
//           variant={mode === "list" ? "contained" : "outlined"}
//           startIcon={<ListIcon />}
//           onClick={() => {
//             setMode("list");
//             resetForm();
//           }}
//         >
//           View Stories
//         </Button>
//         <Button
//           variant={mode === "create" ? "contained" : "outlined"}
//           startIcon={<AddIcon />}
//           onClick={() => {
//             setMode("create");
//             resetForm();
//           }}
//         >
//           Create Story
//         </Button>
//       </Box>

//       {dataLoading && (
//         <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
//           <CircularProgress />
//           <Typography sx={{ ml: 2 }}>Loading...</Typography>
//         </Box>
//       )}

//       {/* LIST MODE (Table) */}
//       {mode === "list" && !dataLoading && (
//         <TableContainer component={Paper}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell>#</TableCell>
//                 <TableCell>Slide</TableCell> {/* Column for media */}
//                 <TableCell>Title</TableCell>
//                 <TableCell>Summary</TableCell>
//                 <TableCell>Category</TableCell>
//                 <TableCell>Tags</TableCell>
//                 <TableCell align="right">Actions</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {stories.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={7} align="center">No stories found. Create one above!</TableCell>
//                 </TableRow>
//               ) : (
//                 stories.map((story, idx) => {
//                   const firstSlide = story.slides && story.slides.length > 0 ? story.slides[0] : null;
//                   const youTubeVideoId = firstSlide?.isExternalLink && firstSlide?.mediaUrl ? getYouTubeVideoId(firstSlide.mediaUrl) : null;
//                   const youTubeThumbnailUrl = youTubeVideoId ? getYouTubeThumbnail(youTubeVideoId) : null;

//                   console.log(`Story ${idx} - First Slide:`, firstSlide); // Debug log
//                   console.log(`Story ${idx} - YouTube ID:`, youTubeVideoId); // Debug log

//                   return (
//                     <TableRow key={story._id} hover>
//                       <TableCell> {idx + 1}</TableCell>
//                       <TableCell>
//                         {firstSlide ? (
//                           firstSlide.isExternalLink && youTubeThumbnailUrl ? (
//                             <img
//                               src={youTubeThumbnailUrl}
//                               alt={`YouTube thumbnail for ${story.title}`}
//                               style={{ width: 100, height: 60, objectFit: "cover", borderRadius: 4 }}
//                             />
//                           ) : firstSlide.isExternalLink ? ( // Fallback for other external links
//                             <LinkIcon color="action" fontSize="large" sx={{ width: 100, height: 60 }} />
//                           ) : firstSlide.mediaType === "image" ? (
//                             <img
//                               src={firstSlide.mediaUrl}
//                               alt={`Slide 1 of ${story.title}`}
//                               style={{ width: 100, height: 60, objectFit: "cover", borderRadius: 4 }}
//                             />
//                           ) : ( // Assuming it's a video if not image and not external link
//                             <video
//                               src={firstSlide.mediaUrl}
//                               style={{ width: 100, height: 60, borderRadius: 8 }}
//                               autoPlay
//                               muted
//                               loop
//                               playsInline
//                             />
//                           )
//                         ) : (
//                           "No media"
//                         )}
//                       </TableCell>
//                       <TableCell>{story.title}</TableCell>
//                       <TableCell
//                         sx={{
//                           maxWidth: 250,
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                           whiteSpace: "nowrap",
//                         }}
//                       >
//                         {story.summary}
//                       </TableCell>
//                       <TableCell>{story.category?.name || "N/A"}</TableCell>
//                       <TableCell>{Array.isArray(story.tags) ? story.tags.join(", ") : ""}</TableCell>
//                       <TableCell align="right">
//                         <IconButton
//                           color="primary"
//                           onClick={() => {
//                             setEditingStoryId(story._id);
//                             setMode("edit");
//                           }}
//                         >
//                           <EditIcon />
//                         </IconButton>
//                         <IconButton
//                           color="error"
//                           onClick={() => handleDeleteStory(story._id)}
//                           disabled={loading}
//                         >
//                           <DeleteIcon />
//                         </IconButton>
//                       </TableCell>
//                     </TableRow>
//                   );
//                 })
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       )}


//       {/* CREATE / EDIT FORM */}
//       {(mode === "create" || mode === "edit") && !dataLoading && (
//         <Box
//           component="form"
//           onSubmit={handleSubmit}
//           sx={{ mt: 3, p: 3, boxShadow: 3, borderRadius: 2 }}
//         >
//           <Typography variant="h5" align="center" sx={{ mb: 3 }}>
//             {mode === "create" ? "Create Story" : "Add Slides to Story"}
//           </Typography>

//           {mode === "create" && (
//             <>
//               <TextField
//                 label="Title"
//                 fullWidth
//                 value={title}
//                 onChange={(e) => setTitle(e.target.value)}
//                 sx={{ mb: 2 }}
//                 required
//               />
//               <TextField
//                 label="Summary"
//                 fullWidth
//                 multiline
//                 rows={3}
//                 value={summary}
//                 onChange={(e) => setSummary(e.target.value)}
//                 sx={{ mb: 2 }}
//               />
//               <FormControl fullWidth sx={{ mb: 2 }} required>
//                 <InputLabel>Category</InputLabel>
//                 <Select value={category} onChange={(e) => setCategory(e.target.value)}>
//                   {categories.length ? (
//                     categories.map((cat) => (
//                       <MenuItem key={cat._id} value={cat._id}>
//                         {cat.name}
//                       </MenuItem>
//                     ))
//                   ) : (
//                     <MenuItem disabled>No categories found</MenuItem>
//                   )}
//                 </Select>
//               </FormControl>

//               {/* Tag Input */}
//               <TextField
//                 label="Add Tags (press Enter)"
//                 fullWidth
//                 value={currentTagInput}
//                 onChange={(e) => setCurrentTagInput(e.target.value)}
//                 onKeyDown={handleAddTag}
//                 sx={{ mb: 2 }}
//               />
//               <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
//                 {tags.map((tag) => (
//                   <Chip
//                     key={tag}
//                     label={tag}
//                     onDelete={() => handleDeleteTag(tag)}
//                     deleteIcon={<ClearIcon />}
//                     color="primary"
//                     variant="outlined"
//                   />
//                 ))}
//               </Box>
//             </>
//           )}

//           {/* Existing slides when editing */}
//           {mode === "edit" && existingSlides.length > 0 && (
//             <Box sx={{ mb: 4, p: 2, border: '1px solid #ddd', borderRadius: 2 }}>
//               <Typography variant="h6" sx={{ mb: 2 }}>
//                 Existing Slides
//               </Typography>
//               <List dense>
//                 {existingSlides.map((sl, idx) => {
//                   const youTubeVideoId = sl.isExternalLink && sl.mediaUrl ? getYouTubeVideoId(sl.mediaUrl) : null;
//                   console.log(`Existing Slide ${idx} - Media URL: ${sl.mediaUrl}, isExternalLink: ${sl.isExternalLink}, MediaType: ${sl.mediaType}, YouTube ID: ${youTubeVideoId}`); // Debug log

//                   return (
//                     <ListItem
//                       key={sl._id || idx}
//                       sx={{ flexDirection: "column", alignItems: "flex-start", mb: 2, borderBottom: '1px dotted #eee', pb: 2 }}
//                     >
//                       <ListItemText primary={`Slide ${idx + 1}`} />
//                       {/* Display media */}
//                       {sl.isExternalLink ? (
//                         <Box sx={{ mt: 1 }}>
//                           <Typography variant="body2" color="text.primary">
//                             External Link: <a href={sl.mediaUrl} target="_blank" rel="noopener noreferrer">{sl.mediaUrl}</a>
//                           </Typography>
//                           {/* Directly embed YouTube iframe if it's a YouTube link */}
//                           {youTubeVideoId ? (
//                             <Box sx={{ width: '100%', maxWidth: 320, paddingTop: '56.25%', position: 'relative', mt: 1 }}> {/* 16:9 aspect ratio */}
//                               <iframe
//                                 width="100%"
//                                 height="100%"
//                                 src={`https://www.youtube.com/embed/${youTubeVideoId}`}
//                                 frameBorder="0"
//                                 allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//                                 allowFullScreen
//                                 title="YouTube video player"
//                                 style={{ position: 'absolute', top: 0, left: 0, borderRadius: 4 }}
//                               ></iframe>
//                             </Box>
//                           ) : (
//                             // Fallback for non-YouTube external links or if ID extraction fails
//                             <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                               <LinkIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} /> No direct embed preview available for this external link.
//                             </Typography>
//                           )}
//                         </Box>
//                       ) : sl.mediaType === "image" ? (
//                         <img
//                           src={sl.mediaUrl}
//                           alt={`Slide ${idx + 1}`}
//                           style={{ width: 320, height: 180, objectFit: "cover", borderRadius: 4, mt: 1 }}
//                         />
//                       ) : sl.mediaType === "video" ? (
//                         <video
//                           src={sl.mediaUrl}
//                           style={{ width: 320, height: 180, borderRadius: 8, mt: 1 }}
//                           controls
//                           muted
//                           loop
//                           playsInline
//                         />
//                       ) : (
//                         <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                           Media not supported or unknown type.
//                         </Typography>
//                       )}

//                       {/* Caption */}
//                       {sl.caption && (
//                         <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                           Caption: {sl.caption}
//                         </Typography>
//                       )}
//                     </ListItem>
//                   );
//                 })}
//               </List>
//             </Box>
//           )}

//           {/* New Slides Section */}
//           <Typography variant="h6" sx={{ mb: 2 }}>
//             {mode === "create" ? "Add Slides" : "Add New Slides"}
//           </Typography>

//           {/* File Upload */}
//           <Button variant="contained" component="label" sx={{ mb: 2 }} startIcon={<AddIcon />}>
//             Upload Files (Images/Videos)
//             <input
//               type="file"
//               hidden
//               multiple
//               accept="image/*,video/*"
//               onChange={handleFileChange}
//             />
//           </Button>

//           {/* External Link Input */}
//           <Box sx={{ display: "flex", alignItems: "flex-end", gap: 1, mb: 2, flexWrap: "wrap" }}>
//             <TextField
//               label="External Media URL (e.g., YouTube Link)"
//               fullWidth={false}
//               sx={{ flexGrow: 1, mr: 1 }}
//               value={currentExternalUrl}
//               onChange={(e) => setCurrentExternalUrl(e.target.value)}
//             />
//             <TextField
//               label="Caption for External Link"
//               fullWidth={false}
//               sx={{ flexGrow: 1, mr: 1 }}
//               value={currentExternalCaption}
//               onChange={(e) => setCurrentExternalCaption(e.target.value)}
//             />
//             <Button
//               variant="outlined"
//               onClick={handleAddExternalLink}
//               startIcon={<LinkIcon />}
//             >
//               Add Link
//             </Button>
//           </Box>


//           {/* New slides list (uploaded files + external links) */}
//           {newSlides.length > 0 && (
//             <Box sx={{ mb: 3, p: 2, border: '1px dashed #ccc', borderRadius: 2 }}>
//               <Typography variant="subtitle1" sx={{ mb: 1 }}>Slides to be added:</Typography>
//               <List dense>
//                 {newSlides.map((s, idx) => {
//                   const youTubeVideoId = s.type === 'external' && s.url ? getYouTubeVideoId(s.url) : null;
//                   const youTubeThumbnailUrl = youTubeVideoId ? getYouTubeThumbnail(youTubeVideoId) : null;

//                   console.log(`New Slide ${idx} - Type: ${s.type}, URL: ${s.url || s.file?.name}, YouTube ID: ${youTubeVideoId}`); // Debug log

//                   return (
//                     <ListItem
//                       key={idx}
//                       secondaryAction={
//                         <IconButton edge="end" aria-label="delete" onClick={() => handleRemoveNewSlide(idx)}>
//                           <CloseIcon />
//                         </IconButton>
//                       }
//                       sx={{ flexDirection: "column", alignItems: "stretch", mb: 1, borderBottom: '1px dotted #eee', pb: 1 }}
//                     >
//                       <ListItemText
//                         primary={
//                           s.type === 'file' ?
//                             `File: ${s.file.name}` :
//                             `External Link: ${s.url}`
//                         }
//                       />
//                       {/* Preview for newly added file slides */}
//                       {s.type === 'file' && s.file.type.startsWith('image') && (
//                         <img src={URL.createObjectURL(s.file)} alt="preview" style={{ width: 100, height: 60, objectFit: 'cover', marginTop: 8 }} />
//                       )}
//                       {s.type === 'file' && s.file.type.startsWith('video') && (
//                         <video src={URL.createObjectURL(s.file)} controls style={{ width: 100, height: 60, marginTop: 8 }} />
//                       )}
//                       {/* Preview for newly added external slides (thumbnail if YouTube, else URL text) */}
//                       {s.type === 'external' && youTubeThumbnailUrl ? (
//                         <img
//                           src={youTubeThumbnailUrl}
//                           alt={`YouTube thumbnail for slide ${idx + 1}`}
//                           style={{ width: 100, height: 60, objectFit: "cover", borderRadius: 4, mt: 1 }}
//                         />
//                       ) : s.type === 'external' && (
//                         <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                           <LinkIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} /> URL: {s.url}
//                         </Typography>
//                       )}
//                       <TextField
//                         label="Slide Caption / Summary"
//                         fullWidth
//                         value={s.caption}
//                         onChange={(e) => handleNewSlideCaptionChange(idx, e.target.value)}
//                         sx={{ mt: 1 }}
//                         placeholder="Enter caption/summary"
//                       />
//                     </ListItem>
//                   );
//                 })}
//               </List>
//             </Box>
//           )}

//           <Button
//             type="submit"
//             variant="contained"
//             fullWidth
//             disabled={loading || (mode === "edit" && newSlides.length === 0)} // Disable submit if no new slides in edit mode
//             startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
//           >
//             {loading ? (mode === "create" ? "Creating..." : "Adding...") : mode === "create" ? "Create Story" : "Add Slides"}
//           </Button>

//           <Button
//             variant="outlined"
//             fullWidth
//             sx={{ mt: 2 }}
//             disabled={loading}
//             onClick={() => {
//               setMode("list");
//               resetForm();
//             }}
//           >
//             Back to Stories List
//           </Button>
//         </Box>
//       )}

//       {/* Snackbar for user feedback */}
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={5000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: "100%" }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default CreateStoryForm;



import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  Snackbar,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import ListIcon from "@mui/icons-material/List";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";
import LinkIcon from "@mui/icons-material/Link"; // For general external links
import CloseIcon from "@mui/icons-material/Close"; // For removing slides
import YouTubeIcon from '@mui/icons-material/YouTube'; // For YouTube specific icon

import {
  createStory,
  getAllCategories,
  getAllStories,
  getStoryById,
  addSlidesToStory,
  deleteStory,
} from "../../../services/adminService"; // Ensure this path is correct

// Helper to extract YouTube video ID from various YouTube URLs
const getYouTubeVideoId = (url) => {
  if (!url) return null;
  // Updated regex to include YouTube Shorts pattern '/shorts/'
  const regExp =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
  const match = url.match(regExp);
  // console.log("getYouTubeVideoId - URL:", url, "Match:", match); // Debug log
  // Check for the length of the matched ID (YouTube IDs are 11 characters)
  return (match && match[2] && match[2].length === 11) ? match[2] : null;
};

// Helper to get YouTube thumbnail URL
const getYouTubeThumbnail = (videoId) => {
  if (!videoId) return null;
  // Using 'mqdefault' for medium quality thumbnail, 'hqdefault' for high quality
  return `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
};

const CreateStoryForm = () => {
  const [mode, setMode] = useState("list"); // list | create | edit
  const [editingStoryId, setEditingStoryId] = useState(null); // Correct variable name

  const [title, setTitle] = useState("");
  const [summary, setSummary] = useState("");
  const [category, setCategory] = useState("");
  const [tags, setTags] = useState([]);
  const [currentTagInput, setCurrentTagInput] = useState("");

  // New state to manage both file uploads and external links
  const [newSlides, setNewSlides] = useState([]); // [{ type: 'file', file: File, caption: '' }, { type: 'external', url: '', caption: '' }]
  const [currentExternalUrl, setCurrentExternalUrl] = useState("");
  const [currentExternalCaption, setCurrentExternalCaption] = useState("");

  const [existingSlides, setExistingSlides] = useState([]); // When editing, existing slides from the story

  const [categories, setCategories] = useState([]);
  const [stories, setStories] = useState([]);

  const [loading, setLoading] = useState(false); // General loading state for actions
  const [dataLoading, setDataLoading] = useState(false); // Loading state for fetching data

  // States for Snackbar feedback
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  // Helper function to show Snackbar messages
  const showMessage = (msg, severity = "success") => {
    setSnackbarMessage(msg);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  // Fetch categories on component mount
  useEffect(() => {
    (async () => {
      try {
        setDataLoading(true);
        const res = await getAllCategories();
        setCategories(res?.data || []);
      } catch {
        showMessage("Failed to fetch categories", "error");
      } finally {
        setDataLoading(false);
      }
    })();
  }, []);

  // Fetch stories when mode changes to 'list'
  const fetchAllStories = async () => {
    try {
      setDataLoading(true);
      const res = await getAllStories();
      setStories(res?.data || []);
    } catch (error) { // Added error parameter for better logging
      console.error("Error fetching stories:", error); // Debug log
      showMessage("Failed to fetch stories", "error");
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    if (mode === "list") fetchAllStories();
  }, [mode]);

  // Fetch story details for editing
  useEffect(() => {
    if (mode !== "edit" || !editingStoryId) return;
    (async () => {
      try {
        setDataLoading(true);
        const res = await getStoryById(editingStoryId);
        const story = res?.data || {};
        console.log("Fetched Story for editing:", story); // Debug log
        setTitle(story.title || "");
        setSummary(story.summary || "");
        setCategory(story.category?._id || story.category || "");
        setTags(Array.isArray(story.tags) ? story.tags : []);
        setExistingSlides(story.slides || []); // Populate existing slides
        setNewSlides([]); // Clear new slides when loading an existing story
      } catch (error) {
        console.error("Error fetching story details:", error); // Debug log
        showMessage("Failed to fetch story details", "error");
        setMode("list"); // Fallback to list mode on error
      } finally {
        setDataLoading(false);
      }
    })();
  }, [mode, editingStoryId]);

  // Reset form fields
  const resetForm = () => {
    setTitle("");
    setSummary("");
    setCategory("");
    setTags([]);
    setCurrentTagInput("");
    setNewSlides([]); // Reset new slides (files + external links)
    setCurrentExternalUrl("");
    setCurrentExternalCaption("");
    setExistingSlides([]); // Reset existing slides
    setEditingStoryId(null);
  };

  // Handle file input change
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);
    setNewSlides((prev) => [
      ...prev,
      ...files.map((f) => ({ type: "file", file: f, caption: "" })),
    ]);
  };

  // Handle adding an external link
  const handleAddExternalLink = () => {
    if (currentExternalUrl.trim()) {
      setNewSlides((prev) => [
        ...prev,
        {
          type: "external",
          url: currentExternalUrl.trim(),
          caption: currentExternalCaption.trim(),
        },
      ]);
      setCurrentExternalUrl("");
      setCurrentExternalCaption("");
    } else {
      showMessage("External URL cannot be empty.", "warning");
    }
  };

  // Handle caption change for a specific slide (newly added)
  const handleNewSlideCaptionChange = (index, value) => {
    setNewSlides((prev) => {
      const copy = [...prev];
      copy[index].caption = value;
      return copy;
    });
  };

  // Handle removing a newly added slide
  const handleRemoveNewSlide = (index) => {
    setNewSlides((prev) => prev.filter((_, i) => i !== index));
  };

  // Handle adding tags
  const handleAddTag = (e) => {
    if (e.key === "Enter" && currentTagInput.trim()) {
      e.preventDefault();
      if (!tags.includes(currentTagInput.trim()))
        setTags((prev) => [...prev, currentTagInput.trim()]);
      setCurrentTagInput("");
    }
  };

  // Handle deleting tags
  const handleDeleteTag = (tag) => {
    setTags((prev) => prev.filter((t) => t !== tag));
  };

  // Handle form submission (Create or Add Slides)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const fd = new FormData();
      const fileSlides = newSlides.filter(s => s.type === 'file');
      const externalSlidesData = newSlides.filter(s => s.type === 'external').map(s => ({
        mediaUrl: s.url,
        caption: s.caption,
      }));

      // Append general story data only for create mode
      if (mode === "create") {
        if (!title || !category) {
          showMessage("Title and Category are required to create a story.", "warning");
          setLoading(false);
          return;
        }
        fd.append("title", title);
        fd.append("summary", summary);
        fd.append("category", category);
        fd.append("tags", JSON.stringify(tags));
      }

      // Append file slides and their captions
      fileSlides.forEach((s, idx) => {
        fd.append("slides", s.file); // 'slides' is the field for file uploads on backend
        fd.append(`captions[${idx}]`, s.caption || ""); // Captions array for files
      });

      // Append external slides as a JSON string
      if (externalSlidesData.length > 0) {
        fd.append("externalSlides", JSON.stringify(externalSlidesData));
      }


      if (mode === "create") {
        await createStory(fd);
        showMessage("Story created successfully!");
      }

      if (mode === "edit") {
        // In edit mode, we only add new slides (files or external links).
        if (fileSlides.length === 0 && externalSlidesData.length === 0) {
          showMessage("No new slides (files or external links) selected to add", "warning");
          setLoading(false);
          return;
        }
        await addSlidesToStory(editingStoryId, fd); // CORRECTED: Changed editingVideoId to editingStoryId
        showMessage("Slides added successfully!");
      }

      resetForm();
      setMode("list");
      fetchAllStories();
    } catch (error) {
      console.error("Submission error:", error); // Debug log
      showMessage(`Failed to ${mode === "create" ? "create" : "update"} story`, "error");
    } finally {
      setLoading(false);
    }
  };

  // Handle deleting a story
  const handleDeleteStory = async (id) => {
    if (!window.confirm("Are you sure you want to delete this story?")) return;
    setLoading(true);
    try {
      await deleteStory(id);
      showMessage("Story deleted successfully!");
      fetchAllStories();
    } catch (error) {
      console.error("Error deleting story:", error); // Debug log
      showMessage("Failed to delete story.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 1000, mx: "auto" }}>
      <Typography variant="h6" align="center" sx={{ mb: 4 }}>
        Story Management
      </Typography>

      {/* Mode Switch Buttons */}
      <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 4, flexWrap: "wrap" }}>
        <Button
          variant={mode === "list" ? "contained" : "outlined"}
          startIcon={<ListIcon />}
          onClick={() => {
            setMode("list");
            resetForm();
          }}
        >
          View Stories
        </Button>
        <Button
          variant={mode === "create" ? "contained" : "outlined"}
          startIcon={<AddIcon />}
          onClick={() => {
            setMode("create");
            resetForm();
          }}
        >
          Create Story
        </Button>
      </Box>

      {dataLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
          <CircularProgress />
          <Typography sx={{ ml: 2 }}>Loading...</Typography>
        </Box>
      )}

      {/* LIST MODE (Table) */}
      {mode === "list" && !dataLoading && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Slide</TableCell> {/* Column for media */}
                <TableCell>Title</TableCell>
                <TableCell>Summary</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Tags</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {stories.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">No stories found. Create one above!</TableCell>
                </TableRow>
              ) : (
                stories.map((story, idx) => {
                  const firstSlide = story.slides && story.slides.length > 0 ? story.slides[0] : null;
                  // Check for both isExternalLink and mediaUrl presence before calling getYouTubeVideoId
                  const youTubeVideoId = firstSlide?.isExternalLink && firstSlide?.mediaUrl ? getYouTubeVideoId(firstSlide.mediaUrl) : null;
                  const youTubeThumbnailUrl = youTubeVideoId ? getYouTubeThumbnail(youTubeVideoId) : null;

                  console.log(`Story ${idx} - First Slide:`, firstSlide); // Debug log
                  console.log(`Story ${idx} - YouTube ID:`, youTubeVideoId); // Debug log
                  console.log(`Story ${idx} - YouTube Thumbnail URL:`, youTubeThumbnailUrl); // Debug log

                  return (
                    <TableRow key={story._id} hover>
                      <TableCell> {idx + 1}</TableCell>
                      <TableCell>
                        {firstSlide ? (
                          firstSlide.isExternalLink && youTubeThumbnailUrl ? (
                            <img
                              src={youTubeThumbnailUrl}
                              alt={`YouTube thumbnail for ${story.title}`}
                              style={{ width: 100, height: 60, objectFit: "cover", borderRadius: 4 }}
                            />
                          ) : firstSlide.isExternalLink ? ( // Fallback for other external links or if YouTube ID not found
                            <LinkIcon color="action" fontSize="large" sx={{ width: 100, height: 60 }} />
                          ) : firstSlide.mediaType === "image" ? (
                            <img
                              src={firstSlide.mediaUrl}
                              alt={`Slide 1 of ${story.title}`}
                              style={{ width: 100, height: 60, objectFit: "cover", borderRadius: 4 }}
                            />
                          ) : ( // Assuming it's a video if not image and not external link
                            <video
                              src={firstSlide.mediaUrl}
                              style={{ width: 100, height: 60, borderRadius: 8 }}
                              autoPlay
                              muted
                              loop
                              playsInline
                            />
                          )
                        ) : (
                          "No media"
                        )}
                      </TableCell>
                      <TableCell>{story.title}</TableCell>
                      <TableCell
                        sx={{
                          maxWidth: 250,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {story.summary}
                      </TableCell>
                      <TableCell>{story.category?.name || "N/A"}</TableCell>
                      <TableCell>{Array.isArray(story.tags) ? story.tags.join(", ") : ""}</TableCell>
                      <TableCell align="right">
                        <IconButton
                          color="primary"
                          onClick={() => {
                            setEditingStoryId(story._id);
                            setMode("edit");
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => handleDeleteStory(story._id)}
                          disabled={loading}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}


      {/* CREATE / EDIT FORM */}
      {(mode === "create" || mode === "edit") && !dataLoading && (
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ mt: 3, p: 3, boxShadow: 3, borderRadius: 2 }}
        >
          <Typography variant="h5" align="center" sx={{ mb: 3 }}>
            {mode === "create" ? "Create Story" : "Add Slides to Story"}
          </Typography>

          {mode === "create" && (
            <>
              <TextField
                label="Title"
                fullWidth
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                sx={{ mb: 2 }}
                required
              />
              <TextField
                label="Summary"
                fullWidth
                multiline
                rows={3}
                value={summary}
                onChange={(e) => setSummary(e.target.value)}
                sx={{ mb: 2 }}
              />
              <FormControl fullWidth sx={{ mb: 2 }} required>
                <InputLabel>Category</InputLabel>
                <Select value={category} onChange={(e) => setCategory(e.target.value)}>
                  {categories.length ? (
                    categories.map((cat) => (
                      <MenuItem key={cat._id} value={cat._id}>
                        {cat.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No categories found</MenuItem>
                  )}
                </Select>
              </FormControl>

              {/* Tag Input */}
              <TextField
                label="Add Tags (press Enter)"
                fullWidth
                value={currentTagInput}
                onChange={(e) => setCurrentTagInput(e.target.value)}
                onKeyDown={handleAddTag}
                sx={{ mb: 2 }}
              />
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
                {tags.map((tag) => (
                  <Chip
                    key={tag}
                    label={tag}
                    onDelete={() => handleDeleteTag(tag)}
                    deleteIcon={<ClearIcon />}
                    color="primary"
                    variant="outlined"
                  />
                ))}
              </Box>
            </>
          )}

          {/* Existing slides when editing */}
          {mode === "edit" && existingSlides.length > 0 && (
            <Box sx={{ mb: 4, p: 2, border: '1px solid #ddd', borderRadius: 2 }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Existing Slides
              </Typography>
              <List dense>
                {existingSlides.map((sl, idx) => {
                  const youTubeVideoId = sl.isExternalLink && sl.mediaUrl ? getYouTubeVideoId(sl.mediaUrl) : null;
                  console.log(`Existing Slide ${idx} - Media URL: ${sl.mediaUrl}, isExternalLink: ${sl.isExternalLink}, MediaType: ${sl.mediaType}, YouTube ID: ${youTubeVideoId}`); // Debug log

                  return (
                    <ListItem
                      key={sl._id || idx}
                      sx={{ flexDirection: "column", alignItems: "flex-start", mb: 2, borderBottom: '1px dotted #eee', pb: 2 }}
                    >
                      <ListItemText primary={`Slide ${idx + 1}`} />
                      {/* Display media */}
                      {sl.isExternalLink ? (
                        <Box sx={{ mt: 1 }}>
                          <Typography variant="body2" color="text.primary">
                            External Link: <a href={sl.mediaUrl} target="_blank" rel="noopener noreferrer">{sl.mediaUrl}</a>
                          </Typography>
                          {/* Directly embed YouTube iframe if it's a YouTube link */}
                          {youTubeVideoId ? (
                            <Box sx={{ width: '100%', maxWidth: 320, paddingTop: '56.25%', position: 'relative', mt: 1 }}> {/* 16:9 aspect ratio */}
                              <iframe
                                width="100%"
                                height="100%"
                                src={`https://www.youtube.com/embed/${youTubeVideoId}`}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                                title="YouTube video player"
                                style={{ position: 'absolute', top: 0, left: 0, borderRadius: 4 }}
                              ></iframe>
                            </Box>
                          ) : (
                            // Fallback for non-YouTube external links or if ID extraction fails
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                              <LinkIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} /> No direct embed preview available for this external link.
                            </Typography>
                          )}
                        </Box>
                      ) : sl.mediaType === "image" ? (
                        <img
                          src={sl.mediaUrl}
                          alt={`Slide ${idx + 1}`}
                          style={{ width: 320, height: 180, objectFit: "cover", borderRadius: 4, mt: 1 }}
                        />
                      ) : sl.mediaType === "video" ? (
                        <video
                          src={sl.mediaUrl}
                          style={{ width: 320, height: 180, borderRadius: 8, mt: 1 }}
                          controls
                          muted
                          loop
                          playsInline
                        />
                      ) : (
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                          Media not supported or unknown type.
                        </Typography>
                      )}

                      {/* Caption */}
                      {sl.caption && (
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                          Caption: {sl.caption}
                        </Typography>
                      )}
                    </ListItem>
                  );
                })}
              </List>
            </Box>
          )}

          {/* New Slides Section */}
          <Typography variant="h6" sx={{ mb: 2 }}>
            {mode === "create" ? "Add Slides" : "Add New Slides"}
          </Typography>

          {/* File Upload */}
          <Button variant="contained" component="label" sx={{ mb: 2 }} startIcon={<AddIcon />}>
            Upload Files (Images/Videos)
            <input
              type="file"
              hidden
              multiple
              accept="image/*,video/*"
              onChange={handleFileChange}
            />
          </Button>

          {/* External Link Input */}
          <Box sx={{ display: "flex", alignItems: "flex-end", gap: 1, mb: 2, flexWrap: "wrap" }}>
            <TextField
              label="External Media URL (e.g., YouTube Link)"
              fullWidth={false}
              sx={{ flexGrow: 1, mr: 1 }}
              value={currentExternalUrl}
              onChange={(e) => setCurrentExternalUrl(e.target.value)}
            />
            <TextField
              label="Caption for External Link"
              fullWidth={false}
              sx={{ flexGrow: 1, mr: 1 }}
              value={currentExternalCaption}
              onChange={(e) => setCurrentExternalCaption(e.target.value)}
            />
            <Button
              variant="outlined"
              onClick={handleAddExternalLink}
              startIcon={<LinkIcon />}
            >
              Add Link
            </Button>
          </Box>


          {/* New slides list (uploaded files + external links) */}
          {newSlides.length > 0 && (
            <Box sx={{ mb: 3, p: 2, border: '1px dashed #ccc', borderRadius: 2 }}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>Slides to be added:</Typography>
              <List dense>
                {newSlides.map((s, idx) => {
                  const youTubeVideoId = s.type === 'external' && s.url ? getYouTubeVideoId(s.url) : null;
                  const youTubeThumbnailUrl = youTubeVideoId ? getYouTubeThumbnail(youTubeVideoId) : null;

                  console.log(`New Slide ${idx} - Type: ${s.type}, URL: ${s.url || s.file?.name}, YouTube ID: ${youTubeVideoId}`); // Debug log

                  return (
                    <ListItem
                      key={idx}
                      secondaryAction={
                        <IconButton edge="end" aria-label="delete" onClick={() => handleRemoveNewSlide(idx)}>
                          <CloseIcon />
                        </IconButton>
                      }
                      sx={{ flexDirection: "column", alignItems: "stretch", mb: 1, borderBottom: '1px dotted #eee', pb: 1 }}
                    >
                      <ListItemText
                        primary={
                          s.type === 'file' ?
                            `File: ${s.file.name}` :
                            `External Link: ${s.url}`
                        }
                      />
                      {/* Preview for newly added file slides */}
                      {s.type === 'file' && s.file.type.startsWith('image') && (
                        <img src={URL.createObjectURL(s.file)} alt="preview" style={{ width: 100, height: 60, objectFit: 'cover', marginTop: 8 }} />
                      )}
                      {s.type === 'file' && s.file.type.startsWith('video') && (
                        <video src={URL.createObjectURL(s.file)} controls style={{ width: 100, height: 60, marginTop: 8 }} />
                      )}
                      {/* Preview for newly added external slides (thumbnail if YouTube, else URL text) */}
                      {s.type === 'external' && youTubeThumbnailUrl ? (
                        <img
                          src={youTubeThumbnailUrl}
                          alt={`YouTube thumbnail for slide ${idx + 1}`}
                          style={{ width: 100, height: 60, objectFit: "cover", borderRadius: 4, mt: 1 }}
                        />
                      ) : s.type === 'external' && (
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                          <LinkIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} /> URL: {s.url}
                        </Typography>
                      )}
                      <TextField
                        label="Slide Caption / Summary"
                        fullWidth
                        value={s.caption}
                        onChange={(e) => handleNewSlideCaptionChange(idx, e.target.value)}
                        sx={{ mt: 1 }}
                        placeholder="Enter caption/summary"
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Box>
          )}

          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={loading || (mode === "edit" && newSlides.length === 0)} // Disable submit if no new slides in edit mode
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
          >
            {loading ? (mode === "create" ? "Creating..." : "Adding...") : mode === "create" ? "Create Story" : "Add Slides"}
          </Button>

          <Button
            variant="outlined"
            fullWidth
            sx={{ mt: 2 }}
            disabled={loading}
            onClick={() => {
              setMode("list");
              resetForm();
            }}
          >
            Back to Stories List
          </Button>
        </Box>
      )}

      {/* Snackbar for user feedback */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateStoryForm;